<ng-container *ngIf="currentPeriod">
  <p class="subtitle">{{ currentPeriod.userCreated }} on {{ currentPeriod.dateCreated | date: "d MMM y" }}</p>
  <table>
    <tr>
      <th>Total number of participating pairs:</th>
      <td>{{ currentPeriod.pairs?.length }}</td>
    </tr>
  </table>
</ng-container>

<ng-container *ngIf="compactTimeline && !expanded">
  <p *ngIf="compactTimeline.dateEnd !== compactTimeline.dateStart" class="subtitle">
    {{ compactTimeline.user }} between {{ compactTimeline.dateStart | date: "d MMM y" }} and {{ compactTimeline.dateEnd | date: "d MMM y" }}
  </p>
  <p *ngIf="compactTimeline.dateEnd == compactTimeline.dateStart" class="subtitle">{{ compactTimeline.user }} on {{ compactTimeline.dateStart | date: "d MMM y" }}</p>
  <ng-container>
    <table>
      <tr *ngIf="compactTimeline.update">
        <th>Updated:</th>
        <td>{{ compactTimeline.update }}</td>
      </tr>
      <tr *ngIf="compactTimeline.create">
        <th>Added:</th>
        <td>{{ compactTimeline.create }}</td>
      </tr>
      <tr *ngIf="compactTimeline.delete">
        <th>Removed:</th>
        <td>{{ compactTimeline.delete }}</td>
      </tr>
      <tr *ngIf="compactTimeline.active">
        <th>Made active:</th>
        <td>{{ compactTimeline.active }}</td>
      </tr>
      <tr *ngIf="compactTimeline.inactive">
        <th>Made inactive:</th>
        <td>{{ compactTimeline.inactive }}</td>
      </tr>
      <tr *ngIf="compactTimeline.enisupload">
        <th>Uploaded through ENIS:</th>
        <td>{{ compactTimeline.enisupload }}</td>
      </tr>
      <tr *ngIf="compactTimeline.approvalrequest">
        <th>Approval requests:</th>
        <td>{{ compactTimeline.approvalrequest }}</td>
      </tr>
      <tr *ngIf="compactTimeline.approvalapproved">
        <th>Approvals approved:</th>
        <td>{{ compactTimeline.approvalapproved }}</td>
      </tr>
      <tr *ngIf="compactTimeline.approvaldenied">
        <th>Approvals denied:</th>
        <td>{{ compactTimeline.approvaldenied }}</td>
      </tr>
      <tr *ngIf="compactTimeline.crossmatchexcluded">
        <th>Combinations excluded:</th>
        <td>{{ compactTimeline.crossmatchexcluded }}</td>
      </tr>
      <tr *ngIf="compactTimeline.crossmatchpositive">
        <th>Positive crossmatches:</th>
        <td>{{ compactTimeline.crossmatchpositive }}</td>
      </tr>
      <tr *ngIf="compactTimeline.crossmatchnegative">
        <th>Negative crossmatches:</th>
        <td>{{ compactTimeline.crossmatchnegative }}</td>
      </tr>
      <tr *ngIf="compactTimeline.crossmatchremoved">
        <th>Removed crossmatches:</th>
        <td>{{ compactTimeline.crossmatchremoved }}</td>
      </tr>
      <tr *ngIf="compactTimeline.chainlocked">
        <th>Chains locked:</th>
        <td>{{ compactTimeline.chainlocked }}</td>
      </tr>
      <tr *ngIf="compactTimeline.chainunlocked">
        <th>Chains unlocked:</th>
        <td>{{ compactTimeline.chainunlocked }}</td>
      </tr>
      <tr *ngIf="compactTimeline.selectedfortransplantation">
        <th>Chains selected for transplantation:</th>
        <td>{{ compactTimeline.selectedfortransplantation }}</td>
      </tr>
      <tr *ngIf="compactTimeline.transplanted">
        <th>Chains transplanted:</th>
        <td>{{ compactTimeline.transplanted }}</td>
      </tr>
      <tr *ngIf="compactTimeline.recipients">
        <th>Recipients participating:</th>
        <td>{{ compactTimeline.recipients }}</td>
      </tr>
      <tr *ngIf="compactTimeline.altruists">
        <th>Altruists participating:</th>
        <td>{{ compactTimeline.altruists }}</td>
      </tr>
    </table>
  </ng-container>
</ng-container>
<ng-container *ngIf="nextPeriod">
  <p class="subtitle">{{ nextPeriod.userCreated }} on {{ nextPeriod.dateCreated | date: "d MMM y" }}</p>
</ng-container>
<ng-container *ngIf="compactTimeline && expanded">
  <ng-container *ngFor="let timeline of compactTimeline.timelines; let last = last">
    <div class="timeline-wrapper" [class.no-border]="last">
      <p class="subtitle">{{ timeline.actionByUser }} on {{ timeline.date | date: "d MMM y" }}</p>
      <div>
        <table class="expandedTimeline">
          <tr *ngIf="timeline.action == 'update'">
            <th>Updated:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>

          <tr *ngIf="timeline.action == 'create'">
            <th>Added:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'delete'">
            <th>Removed:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'active'">
            <th>Made active:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'inactive'">
            <th>Made inactive:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'enisupload'">
            <th>Uploaded through ENIS:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'approvalrequest'">
            <th>Approval requests:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'approvalapproved'">
            <th>Approvals approved:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'approvaldenied'">
            <th>Approvals denied:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'crossmatchexcluded'">
            <th>Combinations excluded:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'crossmatchpositive'">
            <th>Positive crossmatches:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'crossmatchnegative'">
            <th>Negative crossmatches:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'crossmatchremoved'">
            <th>Removed crossmatches:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'chainlocked'">
            <th>Chains locked:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'chainunlocked'">
            <th>Chains unlocked:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'selectedfortransplantation'">
            <th>Chains selected for transplantation:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'transplanted'">
            <th>Chains transplanted:</th>
            <td>{{ timeline.actionCount }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'matchrun'">
            <th>Recipients participating:</th>
            <td>{{ compactTimeline.recipients }}</td>
          </tr>
          <tr *ngIf="timeline.action == 'matchrun'">
            <th>Altruists participating:</th>
            <td>{{ compactTimeline.altruists }}</td>
          </tr>
        </table>
      </div>
    </div>
  </ng-container>
</ng-container>
